export const PRODUCT_UNITS = {
  kg: [
    {
      name: 'g',
      conversion: 1000
    }
  ],
  l: [
    {
      name: 'cl',
      conversion: 100
    }
  ]
};
